import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info?.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="container p-5 text-center">
          <div className="card border-0 shadow-sm mx-auto" style={{ maxWidth: 500 }}>
            <div className="card-body p-5">
              <i className="fas fa-exclamation-triangle text-warning mb-3" style={{ fontSize: 48 }} />
              <h4>Une erreur est survenue</h4>
              <p className="text-muted mb-3">
                {this.state.error?.message || "Erreur inattendue."}
              </p>
              <button
                className="btn btn-dark"
                onClick={() => {
                  this.setState({ hasError: false, error: null });
                  window.location.reload();
                }}
              >
                Recharger la page
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
